<modal-container
  #modal
  class="search-modal modal-product-search-stats-modal"
  [headerTitle]="undefined"
  [headerIconClass]="undefined"
  [isModalForStatsSearch]="true"
  [isHideBtnHidden]="true"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="false"
>
  <ng-container class="modal-button-show">
    <form-row-input
      [label]="'stats.product-search'"
      [model]="searchValue"
      (onFocused)="showModalAndFocusOnSearchInput()"
      (modelChange)="updateSearchValue($event)"
      [placeholder]="'stats.product-search-placeholder'"
    ></form-row-input>
  </ng-container>
  <ng-container class="modal-body-content">
    <div [ngStyle]="{ paddingTop: '20px' }">
      <span [ngStyle]="{ fontSize: '13px', color: '#231F20', fontWeight: '700' }">Vybrat konkrétní produkty</span>
      <form-row-input
        #searchInputInModal
        [label]="undefined"
        [model]="searchValue"
        class="search-modal-input"
        (modelChange)="debouncedSearch($event)"
        [classes]="['w-100']"
      ></form-row-input>
    </div>
    <div
      class="card"
      [ngStyle]="{
        boxShadow: 'none',
        overflow: 'hidden',
        'height.px': modal.availableHeight - 2 * 60 + 7.5 + 10,
        'maxHeight.px': 434 - 2 * 60 + 7.5 + 10,
      }"
    >
      <loading-spinner
        [isLoading]="loading && ((searchValue && searchValue.length > 0) || !products.length)"
        [classesString]="!products.length && loading ? 'top-50' : 'pt-6'"
      ></loading-spinner>
      <div class="m-0" *ngIf="!products || (products && products.length === 0 && !loading)">
        {{ 'no.records' | translate }}
      </div>
      <div class="table-responsive">
        <table class="table" *ngIf="products.length > 0">
          <thead>
            <tr>
              <th class="pl-1" colspan="2">{{ 'product.name' | translate }}</th>
              <th class="text-nowrap text-left">{{ 'product.code3' | translate }}</th>
            </tr>
          </thead>
          <tbody *ngFor="let product of products" class="images" photoGalleryGroup>
            <tr>
              <td class="pl-1 text-left" style="width: 30px">
                <div
                  [photoGallery]="getThumbUrl(product.mainImage, 'w2048wp')"
                  [photoGalleryCaption]="
                    product.fullName +
                    '<br>' +
                    (product.code ? ('product.code' | translate) + product.code : '') +
                    '<br>' +
                    (product.ean ? ' EAN: ' + product.ean : '')
                  "
                >
                  <div class="images-item">
                    <img class="images-item-image" [src]="getThumbUrl(product.mainImage)" [alt]="product.fullName" />
                  </div>
                </div>
              </td>
              <td class="pl-0 text-left" style="width: 45%" (click)="chooseProduct(product)">
                <div class="flex-gap-10 align-items-center">
                  <div>
                    <strong class="hover-primary">{{ product.fullName }}</strong>
                  </div>
                </div>
              </td>
              <td class="text-left" (click)="chooseProduct(product)">
                {{ product.code3 }}
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr *ngIf="pageNumber < maxPageNumber" id="next-page-btn">
              <td class="p-0 border-0 text-center no-hover" colspan="5" *ngIf="hasSpecialAddOrderItemsRole">
                <btn
                  [label]="'title.loading'"
                  [title]="'title.loading' | translate"
                  [classes]="['btn', 'btn-text', 'mt-2', 'w-50']"
                  (onEvent)="searchForProduct(1)"
                  [btnDisabled]="loading"
                ></btn>
              </td>
              <td class="p-0 border-0 text-center no-hover" colspan="5" *ngIf="!hasSpecialAddOrderItemsRole">
                <btn
                  [label]="'title.loading'"
                  [title]="'title.loading' | translate"
                  [classes]="['btn', 'btn-text', 'mt-2', 'w-50']"
                  (onEvent)="searchForProduct(1)"
                  [btnDisabled]="loading"
                ></btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</modal-container>
